
























import Vue from "vue";
import ScheduledReports from "./ScheduledReports.vue";
import ScheduledPdfs from "./ScheduledPdfs.vue";
import { computed, onMounted } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import ScheduledCsvs from "./ScheduledCsvs.vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { UseTabs } from "@/common/composition/use-tabs";
export default Vue.extend({
  components: { ScheduledReports, ScheduledPdfs, ScheduledCsvs, SimpleNavTabs },
  setup(_, { root: { $router } }) {
    const has_pdf_report_schedule_feature = computed(() =>
      SharedState.FeatureHelper.is_enabled("pdf_report_schedule")
    );
    const has_csv_report_schedule_feature = computed(() =>
      SharedState.FeatureHelper.is_enabled("csv_report_scheduler")
    );

    const the_tabs = [
      {
        id: "weekly",
        name: "Weekly Reports",
        icon: "Calendar",
        soon: false,
        disable: false,
      },
      {
        id: "pdf",
        name: "PDF Reports",
        icon: "Pdf",
        soon: false,
        disable: false,
      },
      {
        id: "csv",
        name: "CSV Reports",
        icon: "CSV",
      },
    ];
    const [tabs, current_tab, set_current_tab, , update_tab] = UseTabs(
      the_tabs,
      the_tabs[0]
    );

    onMounted(() => {
      // @ts-ignore
      update_tab(1, {
        ...the_tabs[1],
        disable: !has_pdf_report_schedule_feature.value,
      });

      // @ts-ignore
      update_tab(2, {
        ...the_tabs[2],
        disable: !has_csv_report_schedule_feature.value,
      });
      const { subtab } = $router.currentRoute.query;
      if (subtab) {
        const tab = tabs.value.find((f) => f.id === subtab);
        console.log("subtab:", subtab, " tab: ", tab);
        if (tab) {
          set_current_tab(tab);
        }
      }
    });

    return {
      tabs,
      current_tab,
      set_current_tab,
      has_pdf_report_schedule_feature,
      has_csv_report_schedule_feature,
    };
  },
});
